import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_TYPE } from "../actions-types";
import { getErrorResponse } from "@/utils/helpers/error";
import { AxiosResponse } from "axios";
import { OrganizationStripeService } from "@/utils/services/organization-stripe.services";
import { IOrganizationBillingListResponse, IRequestBillingWithPagination } from "@/utils/types/user.interface";

export const getBillingHistoryList = createAsyncThunk(
    ACTION_TYPE.BILLING_HISTORY_LIST,
    async (
        reqBody: IRequestBillingWithPagination,
        {rejectWithValue}
    ) => {
        try {
            const billingHistoryResponse: AxiosResponse<IOrganizationBillingListResponse
            > =
                await OrganizationStripeService.getBillingList(reqBody);

            return billingHistoryResponse.data;
        } catch (error) {
            return rejectWithValue(getErrorResponse
                (error));
        }
    }
)



